import { useTranslation } from '@/lib/i18n/i18n.client';
import { getText } from '@/lib/i18n/i18n.server';

export const products = [
  'datacenter',
  'datacenter_ip',
  'dedicated_datacenter',
  'mobile',
  'residential',
  'serp',
  'ecommerce_core',
  'ecommerce_advanced',
  'web', // remove after 1 week
  'web_core',
  'web_advanced',
  'social_media',
  'isp_gb',
  'isp_ip',
  'dedicated_isp',
  'site_unblocker',
  'site_unblocker_req',
  'mixed',
  'none', // is just for empty data from prismic, will remove probably in the future
] as const;

export type Product = (typeof products)[number];

type ProductTexts = Record<Product, string>;

const buildProductTexts = (
  texts: ReturnType<typeof useTranslation>['texts']
): ProductTexts => ({
  datacenter: texts.pricing_cards.toggles.pay_per_gb,
  datacenter_ip: texts.pricing_cards.toggles.pay_per_ip,
  dedicated_datacenter: texts.pricing_cards.toggles.dedicated,
  mobile: 'Mobile',
  residential: 'Residential',
  serp: 'SERP',
  ecommerce_core: texts.pricing_cards.toggles.core,
  ecommerce_advanced: texts.pricing_cards.toggles.advanced,
  web: 'Web',
  web_core: texts.pricing_cards.toggles.core,
  web_advanced: texts.pricing_cards.toggles.advanced,
  social_media: 'Social Media',
  dedicated_isp: texts.pricing_cards.toggles.dedicated,
  isp_gb: texts.pricing_cards.toggles.pay_per_gb,
  isp_ip: texts.pricing_cards.toggles.pay_per_ip,
  site_unblocker: texts.pricing_cards.toggles.pay_per_gb,
  site_unblocker_req: texts.pricing_cards.toggles.pay_per_req,
  mixed: texts.pricing_cards.toggles.mixed,
  none: 'None',
});

/** Client-side hook — used by the original 'use client' PricingCards. */
export const useProductsPricingCardsText = (): ProductTexts => {
  const { texts } = useTranslation();
  return buildProductTexts(texts);
};

/** Server-side async — used by SSR_HACK_PricingCards. */
export const getProductsPricingCardsTexts = async (): Promise<ProductTexts> => {
  const texts = await getText();
  return buildProductTexts(texts);
};
